import React from "react"
import { Link } from "~components"
import Card from "./style"
import slugify from "slugify"

export default function ServicesCard({ title, address, time, ...rest }) {
  const slug = slugify(title, {
    lower: true,
    strict: true, // removes special characters like ( ) and accents
    locale: "fr", // helps with replacing é → e, etc.
  })
  return (
    <Card backgrounColor="#fff">
      <Card.Title fontColor="#262729">{title}</Card.Title>
      <Card.Listwrapper>
        <Card.List fontColor="#262729b3">
          <i className="fa fa-map-marker-alt text-primary" />
          {address}
        </Card.List>
        <Card.List fontColor="#262729b3">
          <i className="fa fa-briefcase text-primary" />
          {time}
        </Card.List>
      </Card.Listwrapper>
      <Card.Button className="btn-secondary" as={Link} to={`/emploi/${slug}`}>
        Voir l'offre
      </Card.Button>
    </Card>
  )
}
